import { AfterViewInit, Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SaveChangesOutput } from '@app-asset-config/common/asset-configuration.model';
import { AssetConfigurationService } from '@app-asset-config/services/asset-configuration.service';
import { ConfigurationsExpansionPanelComponent } from '../configurations-expansion-panel/configurations-expansion-panel.component';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmDialogComponent } from '@app-shared/components/dialog/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-basic-configurations',
  templateUrl: './basic-configurations.component.html',
  styleUrls: ['./basic-configurations.component.scss'],
})
export class BasicConfigurationsComponent implements AfterViewInit {
  @ViewChild(ConfigurationsExpansionPanelComponent, { static: true })
  public configExpansionPanel: ConfigurationsExpansionPanelComponent;

  @Output()
  private saveChanges: EventEmitter<SaveChangesOutput> = new EventEmitter();

  constructor(public assetConfigService: AssetConfigurationService, private dialog: MatDialog, private translate: TranslateService) {}

  public ngAfterViewInit() {
    setTimeout(() => {
      this.settingsForm = () => this.configExpansionPanel.settingsForm;
    });
  }

  public settingsForm(): FormGroup {
    return new FormGroup({});
  }

  public onFormChanged(e: boolean) {
    this.assetConfigService.isBasicConfigDirty.next(e);
  }

  public onSaveChanges() {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '480px',
      autoFocus: false,
      disableClose: true,
      panelClass: ['mobile-modal'],
      data: {
        title: this.translate.instant('configurationUpdate'),
        content: this.translate.instant('configurationDescription'),
        actions: [
          { actionButton: this.translate.instant('saveConfigurationCancel'), dialogCloseValue: false },
          { actionButton: this.translate.instant('confirmChanges'), dialogCloseValue: true, primary: true },
        ],
        showCloseIcon: true,
      },
    });
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value) {
        const newConfig = this.settingsForm().getRawValue();
        this.saveChanges.emit({ newConfig, saveForAllDutyTypes: false });
      }
    });
  }
}
